(function (global) {
'use strict';
var VERSION = '1.0.0';
var DEFAULT_TIERS = [{ min: 2, pct: 5 }, { min: 3, pct: 10 }, { min: 4, pct: 15 }];
var SIZE_RE = /(?:^|[\s(])(\d+(?:\.\d+)?)\s?(fl\.?\s?oz|ml|kg|oz|g|l|pads?|pairs?|patches|sheets?|sticks?|tubes?|pcs|pack|ct)\)?(?:\s+(mini))?\s*$/i;
var ICONS = {
check: 'M5 12.5l4.5 4.5L19 7.5',
chev: 'M6 15l6-6 6 6',
ext: 'M14 4h6v6M20 4l-9 9M18 14v5H5V6h5',
x: 'M6 6l12 12M18 6L6 18'
};
function money(c) {
c = Math.round(c);
var d = c / 100;
return '$' + (c % 100 === 0 ? String(d) : d.toFixed(2));
}
function plural(n, one, many) { return n === 1 ? one : many; }
function lsGet(k) { try { return global.localStorage.getItem(k); } catch (e) { return null; } }
function lsSet(k, v) { try { global.localStorage.setItem(k, v); return true; } catch (e) { return false; } }
function lsDel(k) { try { global.localStorage.removeItem(k); } catch (e) { /* ignore */ } }
function fmtSize(n, u, mini) {
u = String(u).toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ');
if (u === 'floz' || u === 'fl oz') { u = 'fl oz'; }
return n + ' ' + u + (mini ? ' mini' : '');
}
function splitTitle(title, vendor) {
var t = String(title || '').trim();
var orig = t;
var sizes = [];
var v = String(vendor || '').trim();
if (v && t.toLowerCase().indexOf(v.toLowerCase() + ' ') === 0) {
t = t.slice(v.length).replace(/^[\s:\-\u2013]+/, '');
}
for (var i = 0; i < 3; i++) {
var m = SIZE_RE.exec(t);
if (!m) { break; }
sizes.unshift(fmtSize(m[1], m[2], m[3]));
t = t.slice(0, m.index).replace(/[\s,\-\u2013(]+$/, '');
}
if (!t) { return { name: orig, size: '' }; }
return { name: t, size: sizes.join(' \u00b7 ') };
}
function cmpText(a, b) { return String(a).localeCompare(String(b), 'en', { sensitivity: 'base' }); }
function normalize(data) {
data = data || {};
var tiers = [];
(data.tiers || []).forEach(function (t) {
var min = Number(t && t.min), pct = Number(t && t.pct);
if (min > 0 && pct > 0) { tiers.push({ min: min, pct: pct }); }
});
if (!tiers.length) { tiers = DEFAULT_TIERS.slice(); }
tiers.sort(function (a, b) { return a.min - b.min; });
var free = Number(data.freeShipping);
if (!(free >= 0)) { free = 50; }
var flat = Number(data.shippingFlat);
if (!(flat >= 0)) { flat = 6.95; }
var seen = {};
var steps = [];
(data.steps || []).forEach(function (s, i) {
if (!s) { return; }
var prods = [];
(s.products || []).forEach(function (p) {
if (!p || p.id == null) { return; }
var pid = String(p.id);
if (seen[pid]) { return; }
var vars = [];
(p.variants || []).forEach(function (v) {
if (v && v.id != null) {
vars.push({ id: String(v.id), title: String(v.title || ''), price: Number(v.priceCents != null ? v.priceCents : p.priceCents) || 0 });
}
});
if (!vars.length && p.variantId != null) {
vars.push({ id: String(p.variantId), title: '', price: Number(p.priceCents) || 0 });
}
if (!vars.length) { return; }
if (p.variantId != null) {
var di = -1;
vars.forEach(function (v, k) { if (v.id === String(p.variantId)) { di = k; } });
if (di > 0) { vars.unshift(vars.splice(di, 1)[0]); }
}
seen[pid] = 1;
var parts = splitTitle(p.title, p.vendor);
prods.push({
id: pid,
handle: String(p.handle || ''),
vendor: String(p.vendor || ''),
name: p.size ? String(p.title || '') : parts.name,
size: p.size ? String(p.size) : parts.size,
image: String(p.image || ''),
url: String(p.url || (p.handle ? '/products/' + p.handle : '#')),
eligible: p.eligible !== false,
variants: vars
});
});
if (prods.length) {
steps.push({ key: String(s.key != null ? s.key : 'step-' + (i + 1)), title: String(s.title || 'Step ' + (i + 1)), why: String(s.why || ''), products: prods });
}
});
return {
tiers: tiers,
freeCents: Math.round(free * 100),
shipCents: Math.round(flat * 100),
heading: String(data.heading || 'Build your own routine'),
subheading: String(data.subheading || 'You pick, you skip, savings stack.'),
steps: steps
};
}
function mount(root, data, opts) {
opts = opts || {};
var doc = root.ownerDocument;
var win = doc.defaultView || global;
var AW = opts.analyticsWindow || win;
var KEY = opts.storageKey || 'byo-routine-v1';
var cfg = normalize(data);
var steps = cfg.steps;
var uid = 0;
var state = { screen: 'entry', idx: 0, picks: {}, chosen: null, sort: 'brand', sheet: false, notice: null, busy: false, vsel: {}, tmp: [], tmpFrom: 'entry' };
var disposers = [];
var els = {};
function add(el, kids) {
if (kids === null || kids === undefined || kids === false) { return; }
if (Array.isArray(kids)) { kids.forEach(function (c) { add(el, c); }); return; }
if (kids.nodeType) { el.appendChild(kids); } else { el.appendChild(doc.createTextNode(String(kids))); }
}
function h(tag, attrs, kids) {
var el = doc.createElement(tag);
if (attrs) {
Object.keys(attrs).forEach(function (k) {
var v = attrs[k];
if (v === null || v === undefined || v === false) { return; }
if (k === 'class') { el.className = v; }
else if (k.slice(0, 2) === 'on' && typeof v === 'function') { el.addEventListener(k.slice(2), v); }
else if (v === true) { el.setAttribute(k, ''); }
else { el.setAttribute(k, String(v)); }
});
}
add(el, kids);
return el;
}
function icon(name) {
var ns = 'http://www.w3.org/2000/svg';
var s = doc.createElementNS(ns, 'svg');
s.setAttribute('viewBox', '0 0 24 24');
s.setAttribute('width', '18');
s.setAttribute('height', '18');
s.setAttribute('aria-hidden', 'true');
s.setAttribute('focusable', 'false');
s.setAttribute('class', 'byo-ico');
var p = doc.createElementNS(ns, 'path');
p.setAttribute('d', ICONS[name]);
s.appendChild(p);
return s;
}
function nid(p) { uid += 1; return 'byo-' + p + '-' + uid; }
function on(target, type, fn, o) { target.addEventListener(type, fn, o); disposers.push(function () { target.removeEventListener(type, fn, o); }); }
function reduced() { try { return win.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
function track(name, d) {
d = d || {};
try { if (typeof opts.onEvent === 'function') { opts.onEvent(name, d); } } catch (e) { /* ignore */ }
try {
if (AW.dataLayer && typeof AW.dataLayer.push === 'function') {
var o = { event: name };
Object.keys(d).forEach(function (k) { o[k] = d[k]; });
AW.dataLayer.push(o);
}
} catch (e) { /* ignore */ }
try { if (typeof AW.gtag === 'function') { AW.gtag('event', name, d); } } catch (e) { /* ignore */ }
}
function activeSteps() {
if (state.chosen && state.chosen.length) {
var f = steps.filter(function (s) { return state.chosen.indexOf(s.key) > -1; });
if (f.length) { return f; }
}
return steps;
}
function stepNo(step) { return activeSteps().indexOf(step) + 1; }
function findProduct(step, pid) {
for (var i = 0; i < step.products.length; i++) { if (step.products[i].id === pid) { return step.products[i]; } }
return null;
}
function findVariant(p, vid) {
for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].id === vid) { return p.variants[i]; } }
return null;
}
function selVariant(p) { return findVariant(p, state.vsel[p.id]) || p.variants[0]; }
function tierFor(n) {
var t = null;
cfg.tiers.forEach(function (x) { if (n >= x.min) { t = x; } });
return t;
}
function nextTier(n) {
for (var i = 0; i < cfg.tiers.length; i++) { if (cfg.tiers[i].min > n) { return cfg.tiers[i]; } }
return null;
}
function pickList() {
var out = [];
activeSteps().forEach(function (s) {
var pk = state.picks[s.key];
if (!pk) { return; }
var p = findProduct(s, pk.pid);
if (!p) { return; }
var v = findVariant(p, pk.vid) || p.variants[0];
out.push({ step: s, product: p, variant: v, price: v.price, eligible: p.eligible });
});
return out;
}
function calc() {
var list = pickList();
var sub = 0, esub = 0, ne = 0;
list.forEach(function (x) { sub += x.price; if (x.eligible) { esub += x.price; ne += 1; } });
var n = list.length;
var t = tierFor(ne);
var pct = t ? t.pct : 0;
var disc = Math.round(esub * pct / 100);
var after = sub - disc;
var ship = n ? (after >= cfg.freeCents ? 0 : cfg.shipCents) : 0;
return { list: list, n: n, ne: ne, sub: sub, pct: pct, disc: disc, after: after, ship: ship, total: after + ship, next: nextTier(ne) };
}
function tierText(c) {
var t0 = cfg.tiers[0];
var extra = c.n > c.ne ? ' ' + (c.n - c.ne) + (c.n - c.ne === 1 ? ' pick is' : ' picks are') + ' not part of Stack & Save.' : '';
if (c.n === 0) { return 'Stack & Save starts at ' + t0.min + ' items (' + t0.pct + '% off).'; }
if (c.ne < t0.min) { return c.n + ' picked. Add ' + (t0.min - c.ne) + ' more for ' + t0.pct + '% off.' + extra; }
var s = c.n + ' picked, ' + c.pct + '% off.';
s += c.next ? ' Add ' + (c.next.min - c.ne) + ' more for ' + c.next.pct + '%.' : ' That\u2019s our top Stack & Save level.';
return s + extra;
}
function shipText(c) {
if (c.n === 0) { return 'Free shipping on ' + money(cfg.freeCents) + '+'; }
var rem = cfg.freeCents - c.after;
return rem > 0 ? money(rem) + ' to free shipping' : 'Free shipping unlocked';
}
function tierFill(c) {
var top = cfg.tiers[cfg.tiers.length - 1].min;
return Math.min(1, c.ne / top);
}
function shipFill(c) { return cfg.freeCents > 0 ? Math.min(1, c.after / cfg.freeCents) : 1; }
function save() {
var has = Object.keys(state.picks).length;
if (!has && !state.chosen) { lsDel(KEY); return; }
var at = state.screen === 'review' ? 'review' : (activeSteps()[state.idx] || {}).key || '';
lsSet(KEY, JSON.stringify({ v: 1, picks: state.picks, chosen: state.chosen, sort: state.sort, at: at, ts: Date.now() }));
}
function readSaved() {
var raw = lsGet(KEY);
if (!raw) { return null; }
var o;
try { o = JSON.parse(raw); } catch (e) { return null; }
if (!o || o.v !== 1 || typeof o.picks !== 'object' || !o.picks) { return null; }
var picks = {};
var n = 0;
steps.forEach(function (s) {
var pk = o.picks[s.key];
if (!pk) { return; }
var p = findProduct(s, String(pk.pid));
if (!p) { return; }
var v = findVariant(p, String(pk.vid));
if (!v) { return; }
picks[s.key] = { pid: p.id, vid: v.id };
n += 1;
});
if (!n) { return null; }
var chosen = null;
if (Array.isArray(o.chosen)) {
chosen = o.chosen.filter(function (k) { return steps.some(function (s) { return s.key === k; }); });
if (!chosen.length || chosen.length === steps.length) { chosen = null; }
}
return { picks: picks, chosen: chosen, sort: o.sort === 'price' ? 'price' : 'brand', at: String(o.at || ''), n: n };
}
function announce(msg) {
els.live.textContent = '';
win.setTimeout(function () { els.live.textContent = msg; }, 30);
}
function setNotice(msg, kind) { state.notice = msg ? { msg: msg, kind: kind || 'info' } : null; renderNotice(); }
function renderNotice() {
if (!els.noticeHost) { return; }
els.noticeHost.textContent = '';
if (!state.notice) { return; }
var n = state.notice;
els.noticeHost.appendChild(h('div', { class: 'byo-notice byo-notice--' + n.kind, role: n.kind === 'warn' ? 'alert' : 'status' }, [
h('p', { class: 'byo-notice__t' }, n.msg),
h('button', { type: 'button', class: 'byo-notice__x', 'aria-label': 'Dismiss message', onclick: function () { setNotice(null); } }, icon('x'))
]));
}
function histState() { return { byo: 1, screen: state.screen, idx: state.idx }; }
function pushHist() {
if (opts.history === false) { return; }
try { win.history.pushState(histState(), '', '#byo-' + (state.screen === 'step' ? 'step-' + (state.idx + 1) : state.screen)); } catch (e) { /* ignore */ }
}
function nav(screen, idx, quiet) {
if (state.sheet) { closeSheet(true); }
state.screen = screen;
if (idx !== undefined && idx !== null) { state.idx = idx; }
if (state.notice && state.notice.keep) { state.notice.keep = false; } else { state.notice = null; }
if (!quiet) { pushHist(); }
render(true);
save();
}
function toTop() {
try {
var r = root.getBoundingClientRect();
if (r.top < 0 || r.top > win.innerHeight * 0.6) { root.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' }); }
} catch (e) { /* ignore */ }
}
function focusHeading() {
var hd = els.main.querySelector('[data-byo-focus]');
if (hd) { try { hd.focus({ preventScroll: true }); } catch (e) { hd.focus(); } }
}
function stepData(step) { return { step: step.title, step_index: stepNo(step), count: calc().n }; }
function goStep(i, via) {
var act = activeSteps();
if (i < 0 || i >= act.length) { return; }
var from = act[state.idx];
if (state.screen === 'step' && i === state.idx) { if (state.sheet) { closeSheet(); } return; }
track('byo_jump', { from_step: from ? from.title : '', step: act[i].title, step_index: i + 1, via: via || 'chip', count: calc().n });
nav('step', i);
}
function goNext() {
var act = activeSteps();
if (state.idx + 1 < act.length) { nav('step', state.idx + 1); } else { nav('review'); }
}
function isPicked(step, pid) { var pk = state.picks[step.key]; return !!pk && pk.pid === pid; }
function setPick(step, p) {
var prev = state.picks[step.key];
if (prev && prev.pid === p.id) {
delete state.picks[step.key];
var c0 = calc();
track('byo_deselect', { step: step.title, step_index: stepNo(step), handle: p.handle, price: selVariant(p).price / 100, count: c0.n });
afterPickChange(p.name + ' removed. ' + tierText(c0));
return;
}
if (prev) {
var pp = findProduct(step, prev.pid);
if (pp) { track('byo_deselect', { step: step.title, step_index: stepNo(step), handle: pp.handle, price: (findVariant(pp, prev.vid) || pp.variants[0]).price / 100, count: calc().n - 1 }); }
}
var v = selVariant(p);
state.picks[step.key] = { pid: p.id, vid: v.id };
var c = calc();
track('byo_select', { step: step.title, step_index: stepNo(step), handle: p.handle, price: v.price / 100, count: c.n });
afterPickChange(p.name + ' chosen. ' + tierText(c));
}
function removePick(step) {
var pk = state.picks[step.key];
if (!pk) { return; }
var p = findProduct(step, pk.pid);
delete state.picks[step.key];
var c = calc();
if (p) { track('byo_deselect', { step: step.title, step_index: stepNo(step), handle: p.handle, price: (findVariant(p, pk.vid) || p.variants[0]).price / 100, count: c.n }); }
afterPickChange((p ? p.name : 'Item') + ' removed. ' + tierText(c));
}
function afterPickChange(msg) {
save();
updateCards();
updateChips();
updateBar();
if (state.sheet) { renderSheetBody(); }
if (state.screen === 'review') { renderMain(); focusHeading(); }
announce(msg);
}
function updateCards() {
if (state.screen !== 'step') { return; }
var step = activeSteps()[state.idx];
if (!step) { return; }
Array.prototype.forEach.call(els.main.querySelectorAll('.byo-card'), function (card) {
var on_ = isPicked(step, card.getAttribute('data-pid'));
card.classList.toggle('byo-card--on', on_);
var b = card.querySelector('.byo-choose');
if (b) {
b.setAttribute('aria-pressed', on_ ? 'true' : 'false');
b.querySelector('.byo-choose__t').textContent = on_ ? 'Chosen' : 'Choose';
}
});
}
function updateChips() {
if (state.screen !== 'step') { return; }
Array.prototype.forEach.call(els.main.querySelectorAll('.byo-chip'), function (chip) {
var has = !!state.picks[chip.getAttribute('data-key')];
chip.classList.toggle('byo-chip--has', has);
var sr = chip.querySelector('.byo-chip__sr');
if (sr) { sr.textContent = has ? ' (picked)' : ''; }
});
}
function trustStrip() {
var items = ['100% authentic', 'Ships in 1 business day', 'Free shipping on ' + money(cfg.freeCents) + '+', 'You choose every item. We never pre-fill.'];
return h('ul', { class: 'byo-trust', 'aria-label': 'Why shop here' }, items.map(function (t) {
return h('li', { class: 'byo-trust__i' }, [icon('check'), h('span', null, t)]);
}));
}
function totalsCard(c, extraClass) {
var rows = [];
rows.push(h('div', { class: 'byo-tot__r' }, [h('dt', null, 'Subtotal'), h('dd', null, money(c.sub))]));
if (c.pct > 0) {
rows.push(h('div', { class: 'byo-tot__r byo-tot__r--save' }, [h('dt', null, 'Stack & Save (' + c.pct + '% off)'), h('dd', null, '\u2212' + money(c.disc))]));
} else {
rows.push(h('div', { class: 'byo-tot__r byo-tot__r--save' }, [h('dt', null, 'Stack & Save'), h('dd', { class: 'byo-tot__soft' }, 'Starts at ' + cfg.tiers[0].min + ' items')]));
}
rows.push(h('div', { class: 'byo-tot__r' }, [h('dt', null, 'Shipping'), h('dd', null, c.n === 0 ? '\u2013' : (c.ship === 0 ? 'Free' : money(c.ship)))]));
rows.push(h('div', { class: 'byo-tot__r byo-tot__r--total' }, [h('dt', null, 'Total'), h('dd', null, money(c.total))]));
return h('div', { class: 'byo-tot ' + (extraClass || '') }, [
h('dl', { class: 'byo-tot__l' }, rows),
h('div', { class: 'byo-meters byo-meters--card' }, [
meterBlock(tierText(c), tierFill(c), 'tier'),
meterBlock(shipText(c), shipFill(c), 'ship')
]),
h('p', { class: 'byo-fine' }, 'Savings and shipping are estimates; taxes are added at checkout.')
]);
}
function meterBlock(txt, frac, kind) {
return h('div', { class: 'byo-meter byo-meter--' + kind }, [
h('p', { class: 'byo-meter__t' }, txt),
h('div', { class: 'byo-meter__bar', 'aria-hidden': 'true' }, h('i', { style: 'width:' + Math.round(frac * 100) + '%' }))
]);
}
function thumb(p) {
return p.image
? h('img', { class: 'byo-thumb', src: p.image, alt: '', width: '56', height: '56', loading: 'lazy', decoding: 'async' })
: h('span', { class: 'byo-thumb byo-thumb--ph', 'aria-hidden': 'true' });
}
function pickRow(x, ctxClass) {
var step = x.step, p = x.product;
return h('li', { class: 'byo-row ' + (ctxClass || '') }, [
thumb(p),
h('div', { class: 'byo-row__b' }, [
h('p', { class: 'byo-row__step' }, 'Step ' + stepNo(step) + ' \u00b7 ' + step.title),
h('p', { class: 'byo-row__name' }, [h('span', { class: 'byo-row__brand' }, p.vendor), ' ', p.name]),
h('p', { class: 'byo-row__meta' }, [p.size, p.variants.length > 1 ? x.variant.title : '', money(x.price), p.eligible === false ? 'not part of Stack & Save' : ''].filter(Boolean).join(' \u00b7 '))
]),
h('div', { class: 'byo-row__a' }, [
h('button', { type: 'button', class: 'byo-btn byo-btn--ghost byo-btn--sm', 'aria-label': 'Swap ' + p.name, onclick: function () { goStep(activeSteps().indexOf(step), state.screen === 'review' ? 'review' : 'panel'); } }, 'Swap'),
h('button', { type: 'button', class: 'byo-btn byo-btn--ghost byo-btn--sm', 'aria-label': 'Remove ' + p.name, onclick: function () { removePick(step); if (state.sheet) { var d = els.sheet && els.sheet.querySelector('[data-byo-sheet-focus]'); if (d) { d.focus(); } } } }, 'Remove')
])
]);
}
function renderEntry() {
var saved = readSaved();
var hid = nid('h1');
var nSteps = steps.length;
var kids = [];
kids.push(h('p', { class: 'byo-eyebrow' }, 'Danella Beauty'));
kids.push(h('h1', { class: 'byo-h1', id: hid, tabindex: '-1', 'data-byo-focus': '1' }, cfg.heading));
kids.push(h('p', { class: 'byo-sub' }, cfg.subheading));
kids.push(h('p', { class: 'byo-lead' }, 'Hi, it\u2019s Danya & Ella. We\u2019ll walk you through a full K-beauty routine, one step at a time. Pick one product per step, or skip it. It\u2019s your routine, your way.'));
kids.push(h('div', { class: 'byo-tiers', role: 'group', 'aria-label': 'Stack & Save savings' }, [
h('p', { class: 'byo-tiers__h' }, 'Stack & Save'),
h('ul', { class: 'byo-tiers__l', role: 'list' }, cfg.tiers.map(function (t, i) {
var last = i === cfg.tiers.length - 1 && cfg.tiers.length > 1;
return h('li', { class: 'byo-tiers__i' }, [h('span', { class: 'byo-tiers__n' }, t.min + (last ? '+' : '') + ' items'), ' ', h('strong', { class: 'byo-tiers__p' }, t.pct + '%')]);
}))
]));
if (saved) {
var rc = h('div', { class: 'byo-resume', role: 'group', 'aria-label': 'Saved picks' }, [
h('p', { class: 'byo-resume__t' }, 'Pick up where you left off'),
h('p', { class: 'byo-resume__s' }, saved.n + ' ' + plural(saved.n, 'pick', 'picks') + ' saved on this device.'),
h('div', { class: 'byo-resume__a' }, [
h('button', { type: 'button', class: 'byo-btn byo-btn--primary', onclick: function () { resume(saved); } }, 'Continue'),
h('button', { type: 'button', class: 'byo-btn byo-btn--ghost', onclick: function () { startFresh(); } }, 'Start fresh')
])
]);
kids.push(rc);
}
kids.push(h('div', { class: 'byo-actions' }, [
h('button', { type: 'button', class: 'byo-btn byo-btn--primary', onclick: function () { startAll(); } }, 'Start'),
h('button', { type: 'button', class: 'byo-btn byo-btn--ghost', onclick: function () { openChoose('entry'); } }, [h('span', null, 'Choose steps'), h('small', { class: 'byo-btn__sub' }, 'I only want a few')])
]));
kids.push(h('p', { class: 'byo-fine byo-center' }, nSteps + ' ' + plural(nSteps, 'step', 'steps') + ', one at a time. Skip anytime.'));
kids.push(trustStrip());
return h('section', { class: 'byo-entry byo-wrap', 'aria-labelledby': hid }, kids);
}
function renderChoose() {
var hid = nid('h2');
var boxes = steps.map(function (s, i) {
var id = nid('tick');
var inp = h('input', { type: 'checkbox', id: id, class: 'byo-tick__in', value: s.key });
inp.checked = state.tmp.indexOf(s.key) > -1;
inp.addEventListener('change', function () {
var at = state.tmp.indexOf(s.key);
if (inp.checked && at < 0) { state.tmp.push(s.key); }
if (!inp.checked && at > -1) { state.tmp.splice(at, 1); }
updateChooseBtn();
});
return h('li', { class: 'byo-tick' }, h('label', { class: 'byo-tick__l', for: id }, [inp, h('span', { class: 'byo-tick__box' }, icon('check')), h('span', { class: 'byo-tick__t' }, [h('span', { class: 'byo-tick__n' }, 'Step ' + (i + 1)), h('span', { class: 'byo-tick__nm' }, s.title)])]));
});
els.chooseBtn = h('button', { type: 'button', class: 'byo-btn byo-btn--primary', onclick: applyChoose }, 'Start with these steps');
els.chooseHint = h('p', { class: 'byo-fine byo-center', 'aria-live': 'polite' }, '');
var sec = h('section', { class: 'byo-choose-screen byo-wrap', 'aria-labelledby': hid }, [
h('p', { class: 'byo-eyebrow' }, 'I only want a few'),
h('h2', { class: 'byo-h2', id: hid, tabindex: '-1', 'data-byo-focus': '1' }, 'Which steps do you want to see?'),
h('p', { class: 'byo-lead' }, 'Tick the ones you\u2019d like. You can change your mind anytime.'),
h('div', { class: 'byo-linkrow' }, [
h('button', { type: 'button', class: 'byo-link', onclick: function () { state.tmp = steps.map(function (s) { return s.key; }); renderMain(); focusHeading(); } }, 'Select all'),
h('button', { type: 'button', class: 'byo-link', onclick: function () { state.tmp = []; renderMain(); focusHeading(); } }, 'Clear')
]),
h('ul', { class: 'byo-ticks', role: 'list' }, boxes),
h('div', { class: 'byo-actions' }, [
els.chooseBtn,
h('button', { type: 'button', class: 'byo-btn byo-btn--ghost', onclick: function () { if (state.tmpFrom === 'step') { nav('step', state.idx); } else { nav('entry'); } } }, 'Back')
]),
els.chooseHint
]);
win.setTimeout(updateChooseBtn, 0);
return sec;
}
function updateChooseBtn() {
if (!els.chooseBtn) { return; }
var n = state.tmp.length;
els.chooseBtn.disabled = n === 0;
els.chooseHint.textContent = n === 0 ? 'Tick at least one step to begin.' : n + ' ' + plural(n, 'step', 'steps') + ' picked for your tour.';
}
function openChoose(from) {
state.tmpFrom = from;
state.tmp = from === 'step' ? activeSteps().map(function (s) { return s.key; }) : (state.chosen ? state.chosen.slice() : []);
nav('choose');
}
function applyChoose() {
if (!state.tmp.length) { return; }
var keep = steps.filter(function (s) { return state.tmp.indexOf(s.key) > -1; }).map(function (s) { return s.key; });
var wasStep = state.tmpFrom === 'step';
var curKey = (activeSteps()[state.idx] || {}).key;
state.chosen = keep.length === steps.length ? null : keep;
var act = activeSteps();
var idx = 0;
if (wasStep) { act.forEach(function (s, i) { if (s.key === curKey) { idx = i; } }); }
if (!wasStep) { track('byo_start', { mode: 'choose_steps', steps: act.length, count: calc().n }); }
nav('step', idx);
}
function startAll() {
state.chosen = null;
state.picks = state.picks || {};
track('byo_start', { mode: 'all_steps', steps: steps.length, count: calc().n });
nav('step', 0);
}
function startFresh() {
state.picks = {};
state.chosen = null;
state.vsel = {};
lsDel(KEY);
renderMain();
announce('Starting fresh. Nothing is picked.');
focusHeading();
}
function resume(saved) {
state.picks = saved.picks;
state.chosen = saved.chosen;
state.sort = saved.sort;
Object.keys(saved.picks).forEach(function (k) { state.vsel[saved.picks[k].pid] = saved.picks[k].vid; });
var act = activeSteps();
track('byo_start', { mode: 'resume', steps: act.length, count: calc().n });
if (saved.at === 'review') { nav('review'); return; }
var idx = 0;
act.forEach(function (s, i) { if (s.key === saved.at) { idx = i; } });
nav('step', idx);
}
function productCard(step, p) {
var nameId = nid('n');
var v = selVariant(p);
var picked = isPicked(step, p.id);
var priceEl = h('p', { class: 'byo-card__price' }, money(v.price));
var kids = [];
kids.push(h('div', { class: 'byo-card__img' }, [
p.image ? h('img', { src: p.image, alt: '', width: '400', height: '400', loading: 'lazy', decoding: 'async' }) : h('span', { class: 'byo-card__ph', 'aria-hidden': 'true' }, p.vendor.charAt(0)),
h('span', { class: 'byo-card__ck', 'aria-hidden': 'true' }, icon('check'))
]));
var body = [
h('p', { class: 'byo-card__brand' }, p.vendor),
h('h3', { class: 'byo-card__name', id: nameId }, p.name)
];
if (p.size) { body.push(h('p', { class: 'byo-card__size' }, p.size)); }
if (p.eligible === false) { body.push(h('p', { class: 'byo-card__note' }, 'Not part of Stack & Save')); }
if (p.variants.length > 1) {
var sid = nid('v');
var sel = h('select', { class: 'byo-var', id: sid }, p.variants.map(function (vv) { return h('option', { value: vv.id }, vv.title || 'Option'); }));
sel.value = v.id;
sel.addEventListener('change', function () {
state.vsel[p.id] = sel.value;
var nv = findVariant(p, sel.value) || p.variants[0];
priceEl.textContent = money(nv.price);
if (isPicked(step, p.id)) { state.picks[step.key] = { pid: p.id, vid: nv.id }; save(); updateBar(); if (state.sheet) { renderSheetBody(); } announce('Option changed. ' + money(nv.price)); }
});
body.push(h('label', { class: 'byo-sr', for: sid }, 'Option for ' + p.name));
body.push(sel);
}
body.push(priceEl);
kids.push(h('div', { class: 'byo-card__body' }, body));
kids.push(h('div', { class: 'byo-card__act' }, [
h('button', { type: 'button', class: 'byo-choose', 'aria-pressed': picked ? 'true' : 'false', 'aria-describedby': nameId, onclick: function () { setPick(step, p); } }, [icon('check'), h('span', { class: 'byo-choose__t' }, picked ? 'Chosen' : 'Choose')]),
h('a', { class: 'byo-link byo-card__more', href: p.url, target: '_blank', rel: 'noopener' }, [h('span', { class: 'byo-link__t' }, 'How to use / details'), h('span', { class: 'byo-sr' }, ' for ' + p.name + ' (opens in a new tab)'), icon('ext')])
]));
return h('article', { class: 'byo-card' + (picked ? ' byo-card--on' : ''), 'data-pid': p.id }, kids);
}
function sortedProducts(step) {
var list = step.products.slice();
if (state.sort === 'price') {
list.sort(function (a, b) { return (a.variants[0].price - b.variants[0].price) || cmpText(a.vendor, b.vendor) || cmpText(a.name, b.name); });
} else {
list.sort(function (a, b) { return cmpText(a.vendor, b.vendor) || cmpText(a.name, b.name); });
}
return list;
}
function renderGrid(step) {
var host = els.grid;
if (!host) { return; }
host.textContent = '';
host.appendChild(h('ul', { class: 'byo-grid', role: 'list' }, sortedProducts(step).map(function (p) { return h('li', { class: 'byo-li' }, productCard(step, p)); })));
}
function renderStep() {
var act = activeSteps();
if (state.idx >= act.length) { state.idx = act.length - 1; }
var step = act[state.idx];
var total = act.length;
var hid = nid('h2');
var chips = act.map(function (s, i) {
var cur = i === state.idx;
return h('li', { class: 'byo-chips__li' }, h('button', {
type: 'button', class: 'byo-chip' + (cur ? ' byo-chip--cur' : '') + (state.picks[s.key] ? ' byo-chip--has' : ''), 'data-key': s.key, 'aria-current': cur ? 'step' : null,
onclick: function () { goStep(i, 'chip'); }
}, [h('span', { class: 'byo-chip__n' }, String(i + 1)), h('span', null, s.title), h('span', { class: 'byo-chip__ck', 'aria-hidden': 'true' }, icon('check')), h('span', { class: 'byo-sr byo-chip__sr' }, state.picks[s.key] ? ' (picked)' : '')]));
});
var pct = Math.round(((state.idx + 1) / total) * 100);
els.grid = h('div', { class: 'byo-gridhost' });
var sec = h('section', { class: 'byo-step byo-wrap', 'aria-labelledby': hid }, [
h('div', { class: 'byo-progress', role: 'progressbar', 'aria-valuemin': '1', 'aria-valuemax': String(total), 'aria-valuenow': String(state.idx + 1), 'aria-label': 'Step ' + (state.idx + 1) + ' of ' + total }, h('i', { style: 'width:' + pct + '%' })),
h('div', { class: 'byo-stephead' }, [
h('h2', { class: 'byo-h2', id: hid, tabindex: '-1', 'data-byo-focus': '1' }, 'Step ' + (state.idx + 1) + ' of ' + total + ' \u00b7 ' + step.title),
h('button', { type: 'button', class: 'byo-link byo-stephead__edit', onclick: function () { openChoose('step'); } }, 'Edit steps')
]),
h('p', { class: 'byo-why' }, step.why),
h('p', { class: 'byo-fine' }, 'Pick one, or skip. Tap Choose again to undo.'),
h('nav', { 'aria-label': 'Jump to a step' }, h('ul', { class: 'byo-chips', role: 'list' }, chips)),
h('div', { class: 'byo-sortrow', role: 'group', 'aria-label': 'Sort products' }, [
h('span', { class: 'byo-sortrow__l' }, 'Sort'),
sortBtn('brand', 'Brand A\u2013Z', step),
sortBtn('price', 'Price low\u2013high', step)
]),
els.grid,
trustStrip()
]);
renderGrid(step);
win.setTimeout(function () {
var cur = sec.querySelector('.byo-chip--cur');
if (cur) { try { var ul = cur.parentNode.parentNode; ul.scrollLeft += cur.getBoundingClientRect().left - ul.getBoundingClientRect().left - 16; } catch (e) { /* ignore */ } }
}, 0);
return sec;
}
function sortBtn(key, label, step) {
return h('button', {
type: 'button', class: 'byo-sortbtn', 'aria-pressed': state.sort === key ? 'true' : 'false', 'data-sort': key,
onclick: function () {
state.sort = key;
Array.prototype.forEach.call(els.main.querySelectorAll('.byo-sortbtn'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-sort') === key ? 'true' : 'false'); });
renderGrid(step);
save();
announce('Sorted by ' + (key === 'price' ? 'price, low to high' : 'brand, A to Z'));
}
}, label);
}
function renderReview() {
var hid = nid('h2');
var c = calc();
var rows = activeSteps().map(function (s) {
var x = null;
c.list.forEach(function (it) { if (it.step === s) { x = it; } });
if (x) { return pickRow(x, 'byo-row--rev'); }
return h('li', { class: 'byo-row byo-row--empty' }, [
h('div', { class: 'byo-row__b' }, [h('p', { class: 'byo-row__step' }, 'Step ' + stepNo(s) + ' \u00b7 ' + s.title)]),
h('div', { class: 'byo-row__a' }, h('button', { type: 'button', class: 'byo-btn byo-btn--ghost byo-btn--sm', 'aria-label': 'Step ' + stepNo(s) + ', ' + s.title + ', skipped. Add one', onclick: function () { goStep(activeSteps().indexOf(s), 'review'); } }, 'Skipped \u00b7 add'))
]);
});
return h('section', { class: 'byo-review byo-wrap', 'aria-labelledby': hid }, [
h('p', { class: 'byo-eyebrow' }, 'Almost there'),
h('h2', { class: 'byo-h2', id: hid, tabindex: '-1', 'data-byo-focus': '1' }, 'Your routine'),
h('p', { class: 'byo-lead' }, c.n ? 'Here\u2019s everything you picked. Swap or remove anything, or add to a skipped step.' : 'Nothing picked yet. Go back to a step whenever you\u2019re ready, or add to any step below.'),
h('ul', { class: 'byo-rows', role: 'list' }, rows),
totalsCard(c, 'byo-tot--review'),
trustStrip()
]);
}
function renderMain() {
els.main.textContent = '';
els.noticeHost = h('div', { class: 'byo-noticehost' });
els.main.appendChild(els.noticeHost);
var node;
if (!steps.length) {
node = h('section', { class: 'byo-entry byo-wrap' }, [
h('h1', { class: 'byo-h1', tabindex: '-1', 'data-byo-focus': '1' }, cfg.heading),
h('p', { class: 'byo-lead' }, 'Our routine builder is restocking. Please check back soon, or browse everything in the shop.'),
h('a', { class: 'byo-btn byo-btn--primary', href: '/collections/all' }, 'Shop all')
]);
} else if (state.screen === 'choose') { node = renderChoose(); }
else if (state.screen === 'step') { node = renderStep(); }
else if (state.screen === 'review') { node = renderReview(); }
else { node = renderEntry(); }
els.main.appendChild(node);
renderNotice();
}
function render(moved) {
root.setAttribute('data-screen', state.screen);
renderMain();
updateBar();
if (moved) {
focusHeading();
toTop();
if (state.screen === 'step') {
var st = activeSteps()[state.idx];
if (st) { track('byo_step_view', stepData(st)); }
} else if (state.screen === 'review') {
var c = calc();
track('byo_review_view', { count: c.n, value: c.total / 100, discount_pct: c.pct });
}
}
}
function buildBar() {
var bar = els.bar;
els.sum = h('button', { type: 'button', class: 'byo-bar__sum', 'aria-haspopup': 'dialog', 'aria-expanded': 'false', onclick: function () { if (state.sheet) { closeSheet(); } else { openSheet(); } } }, [
h('span', { class: 'byo-bar__ttl' }, 'My routine'),
h('span', { class: 'byo-bar__cnt' }, ''),
h('span', { class: 'byo-bar__amt' }, ''),
h('span', { class: 'byo-bar__chev' }, icon('chev'))
]);
els.tierT = h('p', { class: 'byo-meter__t' }, '');
els.tierF = h('i', { style: 'width:0%' });
els.shipT = h('p', { class: 'byo-meter__t' }, '');
els.shipF = h('i', { style: 'width:0%' });
els.left = h('button', { type: 'button', class: 'byo-btn byo-btn--soft', onclick: onLeft }, 'Skip this step');
els.right = h('button', { type: 'button', class: 'byo-btn byo-btn--primary', onclick: onRight }, 'Next');
bar.appendChild(h('div', { class: 'byo-bar__in' }, [
els.sum,
h('div', { class: 'byo-meters' }, [
h('div', { class: 'byo-meter byo-meter--tier' }, [els.tierT, h('div', { class: 'byo-meter__bar', 'aria-hidden': 'true' }, els.tierF)]),
h('div', { class: 'byo-meter byo-meter--ship' }, [els.shipT, h('div', { class: 'byo-meter__bar', 'aria-hidden': 'true' }, els.shipF)])
]),
h('div', { class: 'byo-bar__btns' }, [els.left, els.right])
]));
}
function updateBar() {
var showBar = state.screen === 'step' || state.screen === 'review';
els.bar.hidden = !showBar;
root.setAttribute('data-bar', showBar ? 'on' : 'off');
if (!showBar) { return; }
var c = calc();
els.sum.querySelector('.byo-bar__cnt').textContent = '\u00b7 ' + c.n + ' picked';
els.sum.querySelector('.byo-bar__amt').textContent = c.n ? '\u00b7 ' + money(c.after) : '';
els.sum.setAttribute('aria-label', 'My routine, ' + c.n + ' picked' + (c.n ? ', ' + money(c.after) + ' after savings' : '') + '. Open details');
els.tierT.textContent = tierText(c);
els.tierF.style.width = Math.round(tierFill(c) * 100) + '%';
els.shipT.textContent = shipText(c);
els.shipF.style.width = Math.round(shipFill(c) * 100) + '%';
if (state.screen === 'step') {
var step = activeSteps()[state.idx];
var picked = step && state.picks[step.key];
els.left.textContent = picked ? 'Undo pick' : 'Skip this step';
els.left.disabled = false;
els.right.textContent = state.idx + 1 >= activeSteps().length ? 'Review my routine' : 'Next';
els.right.disabled = false;
} else {
els.left.textContent = 'Back to steps';
els.left.disabled = false;
els.right.textContent = state.busy ? 'Adding\u2026' : 'Add to bag';
els.right.disabled = state.busy || c.n === 0;
}
measureBar();
}
function measureBar() {
try {
var hgt = els.bar.offsetHeight;
if (hgt) { root.style.setProperty('--byo-bar-h', hgt + 'px'); }
} catch (e) { /* ignore */ }
}
function onLeft() {
if (state.screen === 'review') { nav('step', Math.max(0, activeSteps().length - 1)); return; }
var act = activeSteps();
var step = act[state.idx];
if (!step) { return; }
if (state.picks[step.key]) { removePick(step); return; }
track('byo_skip', { step: step.title, step_index: state.idx + 1, count: calc().n });
goNext();
}
function onRight() {
if (state.screen === 'review') { addToBag(); return; }
var act = activeSteps();
var step = act[state.idx];
if (step && !state.picks[step.key]) { track('byo_skip', { step: step.title, step_index: state.idx + 1, count: calc().n }); }
goNext();
}
function openSheet() {
if (state.sheet) { return; }
state.sheet = true;
state.sheetOpener = doc.activeElement;
var tid = nid('sheet');
els.sheetBody = h('div', { class: 'byo-sheet__body' });
els.sheet = h('div', { class: 'byo-sheet', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': tid }, [
h('div', { class: 'byo-sheet__hd' }, [
h('h2', { class: 'byo-h3', id: tid, tabindex: '-1', 'data-byo-sheet-focus': '1' }, 'My routine'),
h('button', { type: 'button', class: 'byo-iconbtn', 'aria-label': 'Close', onclick: function () { closeSheet(); } }, icon('x'))
]),
els.sheetBody
]);
els.scrim = h('div', { class: 'byo-scrim', onclick: function () { closeSheet(); } });
els.sheetHost.appendChild(els.scrim);
els.sheetHost.appendChild(els.sheet);
renderSheetBody();
els.sum.setAttribute('aria-expanded', 'true');
[els.main, els.bar].forEach(function (n) { try { n.inert = true; } catch (e) { /* ignore */ } });
var f = els.sheet.querySelector('[data-byo-sheet-focus]');
if (f) { f.focus(); }
}
function closeSheet(silent) {
if (!state.sheet) { return; }
state.sheet = false;
els.sheetHost.textContent = '';
els.sum.setAttribute('aria-expanded', 'false');
[els.main, els.bar].forEach(function (n) { try { n.inert = false; } catch (e) { /* ignore */ } });
if (!silent) {
var o = state.sheetOpener;
if (o && o.focus && doc.contains(o)) { o.focus(); } else if (els.sum) { els.sum.focus(); }
}
}
function renderSheetBody() {
if (!state.sheet) { return; }
var c = calc();
els.sheetBody.textContent = '';
if (!c.n) {
els.sheetBody.appendChild(h('p', { class: 'byo-lead' }, 'Nothing picked yet. Anything you choose will show up here.'));
} else {
els.sheetBody.appendChild(h('ul', { class: 'byo-rows', role: 'list' }, c.list.map(function (x) { return pickRow(x, 'byo-row--sheet'); })));
}
if (c.n) { els.sheetBody.appendChild(totalsCard(c, 'byo-tot--sheet')); }
else { els.sheetBody.appendChild(h('p', { class: 'byo-fine' }, tierText(c) + ' ' + shipText(c) + '.')); }
els.sheetBody.appendChild(h('div', { class: 'byo-actions' }, [
h('button', { type: 'button', class: 'byo-btn byo-btn--primary', onclick: function () { nav('review'); } }, 'Review my routine'),
h('button', { type: 'button', class: 'byo-btn byo-btn--ghost', onclick: function () { closeSheet(); } }, 'Keep choosing')
]));
}
function onKey(e) {
if (!state.sheet) { return; }
if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeSheet(); return; }
if (e.key === 'Tab') {
var f = els.sheet.querySelectorAll('button:not([disabled]), a[href], select, input, [tabindex="-1"][data-byo-sheet-focus]');
var list = Array.prototype.filter.call(f, function (n) { return n.offsetParent !== null || n === doc.activeElement; });
if (!list.length) { return; }
var first = list[0], last = list[list.length - 1];
if (e.shiftKey && (doc.activeElement === first || !els.sheet.contains(doc.activeElement))) { e.preventDefault(); last.focus(); }
else if (!e.shiftKey && (doc.activeElement === last || !els.sheet.contains(doc.activeElement))) { e.preventDefault(); first.focus(); }
}
}
function getJSON(url, init) {
return win.fetch(url, init).then(function (r) { return r.json().then(function (b) { return { ok: r.ok, status: r.status, body: b }; }, function () { return { ok: r.ok, status: r.status, body: {} }; }); });
}
function fetchAvail(p) {
if (!p.handle) { return Promise.resolve(null); }
return win.fetch('/products/' + encodeURIComponent(p.handle) + '.js', { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } })
.then(function (r) { return r.ok ? r.json() : null; })
.then(function (j) {
if (!j || !Array.isArray(j.variants)) { return null; }
var m = {};
j.variants.forEach(function (v) { m[String(v.id)] = !!v.available; });
return m;
})
.catch(function () { return null; });
}
function applyAvail(step, p, m) {
if (!m) { return false; }
p.variants = p.variants.filter(function (v) { return m[v.id] !== false; });
if (!p.variants.length) {
step.products = step.products.filter(function (x) { return x !== p; });
return true;
}
return false;
}
function dropEmptySteps() {
var before = steps.length;
var curKey = (activeSteps()[state.idx] || {}).key;
for (var i = steps.length - 1; i >= 0; i--) { if (!steps[i].products.length) { delete state.picks[steps[i].key]; steps.splice(i, 1); } }
if (steps.length !== before) {
var act = activeSteps();
var ni = -1;
act.forEach(function (s, k) { if (s.key === curKey) { ni = k; } });
state.idx = ni > -1 ? ni : Math.min(state.idx, Math.max(0, act.length - 1));
}
}
function refreshStep(step) {
return Promise.all(step.products.slice().map(function (p) { return fetchAvail(p).then(function (m) { return { p: p, m: m }; }); })).then(function (rs) {
rs.forEach(function (r) {
var gone = applyAvail(step, r.p, r.m);
var pk = state.picks[step.key];
if (pk && pk.pid === r.p.id && (gone || !findVariant(r.p, pk.vid))) { delete state.picks[step.key]; }
});
dropEmptySteps();
});
}
function handleSoldOut(body) {
var list = pickList();
return Promise.all(list.map(function (x) { return fetchAvail(x.product).then(function (m) { return { x: x, m: m }; }); })).then(function (rs) {
var lost = [];
rs.forEach(function (r) {
if (r.m && r.m[r.x.variant.id] === false) { lost.push(r.x); }
});
if (!lost.length) {
var d = body && (body.description || body.message);
setNotice('Hmm, we couldn\u2019t add everything just now' + (d ? ' (' + d + ')' : '') + '. Your picks are saved, so please try again in a moment.', 'warn');
return;
}
var names = lost.map(function (x) { return x.product.name; });
var firstStep = lost[0].step;
lost.forEach(function (x) {
var m = {};
m[x.variant.id] = false;
applyAvail(x.step, x.product, m);
if (state.picks[x.step.key] && state.picks[x.step.key].vid === x.variant.id) { delete state.picks[x.step.key]; }
});
return refreshStep(firstStep).then(function () {
var msg = names.length === 1
? 'Oh no, ' + names[0] + ' just sold out. We took it off your list; everything else is saved. Pick another, or skip this step.'
: 'Oh no, ' + names.join(' and ') + ' just sold out. We took them off your list; everything else is saved. Pick another, or skip.';
var act = activeSteps();
var at = act.indexOf(firstStep);
state.notice = { msg: msg, kind: 'warn', keep: true };
save();
if (at > -1) { nav('step', at); } else { nav('review'); }
announce(msg);
});
});
}
function addToBag() {
if (state.busy) { return; }
var c = calc();
if (!c.n) { return; }
var items = [];
var seen = {};
c.list.forEach(function (x) { if (!seen[x.variant.id]) { seen[x.variant.id] = 1; items.push({ id: Number(x.variant.id), quantity: 1 }); } });
state.busy = true;
setNotice(null);
updateBar();
var done = function () { state.busy = false; updateBar(); };
var inCart = {};
getJSON('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
.then(function (r) { if (r.ok && r.body && Array.isArray(r.body.items)) { r.body.items.forEach(function (it) { inCart[String(it.variant_id || it.id)] = 1; }); } }, function () { /* carry on without it */ })
.then(function () {
var toAdd = items.filter(function (i) { return !inCart[String(i.id)]; });
if (!toAdd.length) { return { ok: true, skipped: true }; }
return getJSON('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: toAdd }) });
})
.then(function (res) {
if (res.ok) {
var hs = c.list.map(function (x) { return x.product.handle; }).join(',');
track('byo_add_to_bag', { step: 'review', handle: hs, price: c.total / 100, count: c.n, value: c.total / 100, discount_pct: c.pct });
if (opts.onAdded) { try { opts.onAdded(res); } catch (e) { /* ignore */ } }
if (opts.noRedirect) { done(); setNotice('Added to your bag.', 'info'); return; }
win.setTimeout(function () { win.location.assign(opts.cartUrl || '/cart'); }, 150);
return;
}
done();
if (res.status === 422) { return handleSoldOut(res.body); }
setNotice('That didn\u2019t go through just now. Your picks are saved, so please try again in a moment.', 'warn');
})
.catch(function () {
done();
setNotice('That didn\u2019t go through just now. Your picks are saved, so please try again in a moment.', 'warn');
});
}
function boot() {
root.textContent = '';
root.classList.add('byo');
els.main = h('div', { class: 'byo-main' });
els.bar = h('div', { class: 'byo-bar', hidden: true, role: 'region', 'aria-label': 'My routine summary' });
els.sheetHost = h('div', { class: 'byo-sheethost' });
els.live = h('div', { class: 'byo-sr', role: 'status', 'aria-live': 'polite' });
root.appendChild(els.main);
root.appendChild(els.bar);
root.appendChild(els.sheetHost);
root.appendChild(els.live);
buildBar();
on(doc, 'keydown', onKey);
on(win, 'popstate', function (e) {
var s = e.state;
if (state.sheet) { closeSheet(true); }
if (s && s.byo) { state.screen = s.screen; state.idx = s.idx || 0; render(true); }
else if (state.screen !== 'entry') { state.screen = 'entry'; render(true); }
});
on(win, 'resize', measureBar);
if (typeof win.IntersectionObserver === 'function') {
try {
var io = new win.IntersectionObserver(function (en) { en.forEach(function (x) { els.bar.classList.toggle('byo-bar--away', !x.isIntersecting); }); });
io.observe(root);
disposers.push(function () { io.disconnect(); });
} catch (e) { /* ignore */ }
}
if (typeof win.ResizeObserver === 'function') {
try {
var ro = new win.ResizeObserver(measureBar);
ro.observe(els.bar);
disposers.push(function () { ro.disconnect(); });
} catch (e) { /* ignore */ }
}
if (opts.history !== false) { try { win.history.replaceState(histState(), '', win.location.href); } catch (e) { /* ignore */ } }
render(false);
track('byo_view', { steps: steps.length });
}
boot();
return {
version: VERSION,
state: state,
steps: steps,
destroy: function () { disposers.forEach(function (d) { d(); }); root.textContent = ''; },
_calc: calc
};
}
function init() {
var root = document.getElementById('byo-root');
var node = document.getElementById('byo-data');
if (!root || !node) { return; }
try {
var data = JSON.parse(node.textContent);
mount(root, data, {});
} catch (e) {
root.textContent = '';
var p = document.createElement('p');
p.className = 'byo-lead';
p.appendChild(document.createTextNode('We couldn\u2019t load the routine builder just now. Please refresh, or '));
var a = document.createElement('a');
a.href = '/collections/all';
a.textContent = 'shop everything here';
p.appendChild(a);
p.appendChild(document.createTextNode('.'));
root.appendChild(p);
}
}
var first = !global.BYORoutine;
global.BYORoutine = { mount: mount, init: init, version: VERSION, _splitTitle: splitTitle, _normalize: normalize };
if (first) { document.addEventListener('shopify:section:load', function () { global.BYORoutine.init(); }); }
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})(window);